module.exports = __webpack_public_path__ + "d55f9e8f0b14968dfa128f3458fab15b.svg";